import { take } from "rxjs/operators";
import {
  Component,
  ViewChildren,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  NgZone,
} from "@angular/core";
import { KpiService } from "../kpi/kpi.service";
import { Title } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { ViewChild } from "@angular/core";
import { ListSettingsModalComponent } from "../dashboard-elements/list-settings-modal/list-settings-modal.component";
import { AddStudentsToGroupModalComponent } from "../dashboard-elements/add-students-to-group-modal/add-students-to-group-modal.component";
import { ExportStudentsToCsvModalComponent } from "../dashboard-elements/export-students-to-csv-modal/export-students-to-csv-modal.component";
import { getStudentsState } from "../store/appState";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  student,
  studentDataSearch,
  StudentDataDemographicFilter,
  View,
  Group,
  StudentDataFilter,
} from "../store/students/state";
import { Store } from "@ngrx/store";
import { formatDate } from "@angular/common";
import {
  GetStudentDataAction,
  SelectStudentAction,
  SelectAllStudentsAction,
  UpdateSelectedViewId,
} from "../store/students/actions";
import { Router, ActivatedRoute } from "@angular/router";
import {
  map,
  forEach,
  keys,
  filter,
  has,
  isEqual,
  every,
  some,
  find,
  orderBy,
  sortBy,
  cloneDeep,
  forOwn,
  pickBy,
  startsWith,
  values,
  chain,
  union,
  differenceWith,
  flatten,
} from "lodash";
import { OOPS_MESSAGES, TIERS } from "../constants";
import {
  DistrictSchools,
  OurStudentsHeaderMetadata,
  SchoolMetadata,
} from "../shared/interfaces";

@Component({
  selector: "student-comparison",
  templateUrl: "./student-comparison.component.html",
  styleUrls: ["./student-comparison.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentComparisonComponent implements OnInit, AfterViewInit {
  students: Array<student>;
  totalCount;
  teachersForDropdown;
  sectionsForDropdown;
  school;
  schoolOverall = {};
  columns = [];
  districtMetrics = {};
  panels;
  originalPanels;
  originalColumns = [];
  dataTable;
  schools;
  userInfo;
  schoolsForDropdown;
  errorMessage;
  selectedSchool;
  selectedUserSchool;
  userViews: Array<View>;
  userViewsForDropdown = [];
  demographicsForDropdown;
  districtDemographics;
  selectedView: View;
  sortsAndFilters: View = { sortColumns: [], filterColumns: [] };

  studentState: Observable<any>;
  currentPageNum: number = 0;
  currentPageSize: number = 10;
  selectedTeacherId: string;
  selectedSectionId: string;
  selectedDemographicFilters;
  selectedDemoFilterVals = [];
  loadingStudentData: boolean = true;
  selectedListItem;
  selectedAll: boolean;
  groups: Array<Group>;
  groupsForDropdown = [];
  hasStudentSelected: boolean;
  listsForDropdown;
  selectedGroup: Group;
  groupStatusSort: string;
  groupStatusFilters: Array<string>;
  exportingStudentData: boolean = false;
  initialSelectedGroupId: number;
  initiallySelectedSchoolId: string;
  selectedViewId: number;
  noListObj = { id: "-1", text: "- No list -", list: "" };
  schoolColumns;
  schoolPanels;

  teachersAndSectionsForDropdown;
  selectedTeacherOrSectionId;
  selectedTeacherOrSection;

  @ViewChildren("studentComp") studentComps: any;

  @ViewChild("studentSchoolsDropdown")
  studentSchoolsDropdown;
  @ViewChild("studentFiltersDropdown", { static: true }) studentFiltersDropdown;
  @ViewChild("teachersDropdown") teachersDropdown;
  @ViewChild("sectionsDropdown") sectionsDropdown;
  @ViewChild("demoDropdown") demoDropdown;
  @ViewChild("listsDropdown") listsDropdown;
  @ViewChild("studentCompTable", { static: true }) studentCompTable;

  constructor(
    public kpiService: KpiService,
    private titleService: Title,
    public ducktective: ChangeDetectorRef,
    public zone: NgZone,
    private store: Store<any>,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.kpiService.errorMessage = null;
    this.studentState = this.store.select(getStudentsState);
    this.studentState.pipe(take(1)).subscribe((state) => {
      if (
        has(this.activatedRoute.snapshot.queryParamMap, "params") &&
        this.activatedRoute.snapshot.queryParamMap["params"] &&
        keys(this.activatedRoute.snapshot.queryParamMap["params"]) &&
        keys(this.activatedRoute.snapshot.queryParamMap["params"]).length > 0
      ) {
        // we have url parameters in our route
        let studentDataSearchFromQueryParams = this.createStudentDataSearchObjFromUrlParams(
          this.activatedRoute.snapshot.queryParamMap
        );
        let selectedViewIdFromQueryParams = this.activatedRoute.snapshot.queryParamMap.get(
          "selectedViewId"
        );
        if (
          state &&
          state.students &&
          isEqual(state.studentDataSearch, studentDataSearchFromQueryParams)
        ) {
          // the studentDataSearch object built from the query parameters is the same as what is already in our store
          if (state && state.selectedViewId == selectedViewIdFromQueryParams) {
            // the viewId is also the same as in our store
            // -> just set the initial filters
            this.setInitialFilters(
              state.studentDataSearch,
              state.selectedViewId
            );
          } else {
            // the view id is different than in our store
            this.store.dispatch(
              new UpdateSelectedViewId(
                selectedViewIdFromQueryParams
                  ? parseInt(selectedViewIdFromQueryParams)
                  : null
              )
            );
            this.setInitialFilters(
              state.studentDataSearch,
              selectedViewIdFromQueryParams
                ? parseInt(selectedViewIdFromQueryParams)
                : null
            );
          }
        } else {
          // get students and update the student data search object in the store
          this.store.dispatch(
            new GetStudentDataAction(studentDataSearchFromQueryParams)
          );
          if (
            !state ||
            (state && state.selectedViewId != selectedViewIdFromQueryParams)
          ) {
            // update the selected view in the store
            this.store.dispatch(
              new UpdateSelectedViewId(
                selectedViewIdFromQueryParams
                  ? parseInt(selectedViewIdFromQueryParams)
                  : null
              )
            );
          }
          this.setInitialFilters(
            studentDataSearchFromQueryParams,
            selectedViewIdFromQueryParams
              ? parseInt(selectedViewIdFromQueryParams)
              : null
          );
        }
      } else if (state && state.students) {
        // we have no url params but we do have state saved in our store
        this.setInitialFilters(state.studentDataSearch, state.selectedViewId);
        // now update the url to include the params
        this.updateUrlParams(state.studentDataSearch, state.selectedViewId);
      } else {
        // no current students in store
        this.getStudents();
      }
      this.getUserInfoAndSetUpTable();
    });
    this.studentState.subscribe((state) => {
      if (state) {
        this.loadingStudentData = state.loading;
        this.students = state.students;
        this.totalCount = state.totalCount;
        state.students
          ? (this.selectedAll = every(state.students, ["selected", true]))
          : (this.selectedAll = null);
        state.students
          ? (this.hasStudentSelected = some(state.students, ["selected", true]))
          : (this.hasStudentSelected = null);
      } else {
        this.loadingStudentData = null;
        this.students = null;
        this.totalCount = null;
        this.selectedAll = null;
        this.hasStudentSelected = null;
      }
    });
  }

  ngAfterViewInit() {}

  removeFocusFromDropdown() {
    // after a dropdown item is selected, we disable the dropdown temporarily while everything loads
    // there was a change detection issue with ng-select where the focus was refusing to be removed afterwards
    // so the dropdown was focused, even on outside-dropdown click, until it was opened again
    if (this.studentSchoolsDropdown) {
      this.studentSchoolsDropdown.onInputBlur();
    }
    if (this.teachersDropdown) {
      this.teachersDropdown.onInputBlur();
    }
    if (this.sectionsDropdown) {
      this.sectionsDropdown.onInputBlur();
    }
    if (this.demoDropdown) {
      this.demoDropdown.onInputBlur();
    }
    if (this.listsDropdown) {
      this.listsDropdown.onInputBlur();
    }
  }

  getDistrictDemographics(isFirstTimeInitialization = false) {
    this.kpiService.getDistrictSchools().subscribe(
      (data: DistrictSchools) => {
        if (data) {
          this.districtDemographics = data.demographics;
          if (this.selectedSchool) {
            this.getFiltersForSelectedSchool(isFirstTimeInitialization);
          } else {
            this.populateDemographicFilterValues(isFirstTimeInitialization);
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getFiltersForSelectedSchool(isFirstTimeInitialization = false) {
    if (this.userInfo.role == "teacher") {
      //For teachers, accessible students are stored by school inside userInfo.schools
      this.selectedUserSchool = find(this.userInfo.schools, [
        "systemSchoolId",
        this.selectedSchool.id,
      ]);
    }
    this.kpiService.getSchoolInfo(this.selectedSchool.id).subscribe(
      (data) => {
        this.selectedUserSchool = cloneDeep(data);
        let tempDemographics = {};
        forOwn(this.selectedUserSchool.demographics, (values, key) => {
          tempDemographics[key] = map(values, "id");
        });
        this.selectedUserSchool.demographics = tempDemographics;
        this.populateDemographicFilterValues(isFirstTimeInitialization);
        this.populateTeachersAndSectionsDropdown();
        if (!isFirstTimeInitialization) {
          this.clearTeacherAndSectionFilter(); //Also gets students
        }
        this.somethingChanged();
      },
      (error) => {
        this.kpiService.showError(
          error,
          OOPS_MESSAGES.ACCESS_CONTENT,
          OOPS_MESSAGES.RENDER_DASHBOARD
        );
      }
    );
  }

  getViewsForUser() {
    this.kpiService.getMosaicStudentViews().subscribe(
      (data) => {
        this.userViews = map(data, (userView: any) => {
          return {
            ...userView,
            sortColumns: this.makeInts(userView.sortColumns),
            filterColumns: this.makeInts(userView.filterColumns),
          };
        });
        this.userViewsForDropdown = this.generateListItemsForDropdown(
          this.userViews,
          "view"
        );
        if (this.selectedViewId) {
          // we have an initially selected view
          this.selectedView = find(this.userViews, ["id", this.selectedViewId]);
          this.selectedListItem = find(this.userViewsForDropdown, [
            "id",
            this.selectedViewId,
          ]);
          this.updateViewPanel();
        }
        this.generateListsDropdown();
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getGroupsForUser() {
    let schoolId = this.selectedSchool ? this.selectedSchool.id : null;
    this.kpiService.getGroups(this.userInfo.role, schoolId).subscribe(
      (data: any) => {
        let groups = data;
        this.groups = this.mapEfficacyCriteriaForGroups(groups);
        this.groupsForDropdown = this.generateListItemsForDropdown(
          this.groups,
          "group"
        );
        if (this.initialSelectedGroupId) {
          this.selectedGroup = filter(this.groups, [
            "id",
            this.initialSelectedGroupId,
          ])[0];
          this.selectedListItem = find(this.groupsForDropdown, [
            "id",
            this.initialSelectedGroupId,
          ]);
          this.updateGroupPanel(true);
        }
        this.generateListsDropdown();
      },
      (err) => {
        console.error(err);
      }
    );
  }

  mapEfficacyCriteriaForGroups(groups) {
    return map(groups, (group: any) => {
      return {
        ...group,
        efficacyCriteria: map(group.efficacyCriteria, (criteria: any) => {
          return {
            student_kpi_id: criteria.studentKpiId,
            min_value: criteria.minValue,
            max_value: criteria.maxValue,
          };
        }),
      };
    });
  }

  makeInts(cols) {
    return map(cols, (col: any) => {
      return { ...col, student_kpi_id: parseInt(col.student_kpi_id) };
    });
  }

  generateListItemsForDropdown(listItems, type) {
    let mappedListItems: any = map(listItems, function (listItem: any) {
      return {
        id: listItem["id"],
        text: listItem["name"],
        type: type,
        list: listItem["isSharedWithMe"]
          ? type == "group"
            ? "Groups Shared with Me"
            : "Views Shared with Me"
          : type == "group"
          ? "My Groups"
          : "My Views",
      };
    });
    return orderBy(
      mappedListItems,
      [
        (listItem) => listItem["list"],
        (listItem) => listItem["text"].toLowerCase(),
      ],
      [type == "group" ? "desc" : "asc", "asc"]
    );
  }

  generateListsDropdown() {
    this.listsForDropdown = [
      this.noListObj,
      ...this.groupsForDropdown,
      ...this.userViewsForDropdown,
    ];
    this.somethingChanged();
  }

  getUserInfoAndSetUpTable() {
    return this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.userInfo = data;
        this.schools = data.schools;
        this.kpiService.title = data.customer_name;
        this.schoolsForDropdown = map(this.schools, function (school: any) {
          return {
            id: school.systemSchoolId,
            text: school.officialSchoolName,
          };
        });
        this.schoolsForDropdown = sortBy(this.schoolsForDropdown, "text");
        if (this.schoolsForDropdown.length > 1) {
          this.schoolsForDropdown.unshift({
            id: "none",
            text: "- No filter -",
          });
        }
        if (this.initiallySelectedSchoolId) {
          this.selectedSchool = find(this.schoolsForDropdown, [
            "id",
            this.initiallySelectedSchoolId,
          ]);
        } else if (this.schoolsForDropdown.length == 1) {
          // user has access to one school
          this.selectedSchool = this.schoolsForDropdown[0];
        }
        this.setUpTable(true);
      },
      (error) => {
        this.kpiService.title = "Student Comparison";
        console.error(error);
      }
    );
  }

  setUpTable(isFirstTimeInitialization = false) {
    return this.kpiService.getOurStudentsHeaderData().subscribe(
      (data: OurStudentsHeaderMetadata) => {
        this.panels = data.panels;
        this.columns = data.columns;
        this.originalPanels = cloneDeep(data.panels);
        this.originalColumns = cloneDeep(data.columns);
        this.districtMetrics = data.district_metrics;
        if (
          this.schoolsForDropdown.length == 1 ||
          this.initiallySelectedSchoolId
        ) {
          // user has access to one school OR we are initializing the page with a pre-selected school
          this.getHeaderRowForSelectedSchool();
        } else {
          this.restoreDistrictOverallHeaderRow();
        }
        this.getDistrictDemographics(isFirstTimeInitialization);
        this.getViewsForUser();
        this.getGroupsForUser();
      },
      (error) => {
        this.kpiService.showError(
          error,
          OOPS_MESSAGES.ACCESS_CONTENT,
          OOPS_MESSAGES.RENDER_DASHBOARD
        );
      }
    );
  }

  getStudentDataSearch() {
    let schoolId = this.selectedSchool ? this.selectedSchool.id : null;
    let studentDataSearch: studentDataSearch = {
      pageNumber: this.currentPageNum,
      pageSize: this.currentPageSize,
    };
    if (schoolId) {
      studentDataSearch["schoolIds"] = [schoolId];
    }
    if (this.selectedTeacherId) {
      studentDataSearch["staffIds"] = [this.selectedTeacherId];
    }
    if (this.selectedSectionId) {
      studentDataSearch["sectionIds"] = [this.selectedSectionId];
    }
    if (this.selectedDemographicFilters) {
      studentDataSearch["demographicFilters"] = this.selectedDemographicFilters;
    }
    if (
      this.sortsAndFilters &&
      this.sortsAndFilters.filterColumns &&
      this.sortsAndFilters.filterColumns.length > 0
    ) {
      studentDataSearch["metricFilters"] = map(
        this.sortsAndFilters.filterColumns,
        (column: any) => {
          return {
            studentKpiId: column.student_kpi_id,
            minValue: column.min_value,
            maxValue: column.max_value,
          };
        }
      );
    }
    if (
      this.sortsAndFilters &&
      this.sortsAndFilters.sortColumns &&
      this.sortsAndFilters.sortColumns.length > 0
    ) {
      studentDataSearch["metricSorts"] = map(
        this.sortsAndFilters.sortColumns,
        (column: any) => {
          return {
            studentKpiId: column.student_kpi_id,
            sortAscending: column.sort_ascending,
          };
        }
      );
    }
    if (this.selectedGroup) {
      studentDataSearch["studentGroupId"] = this.selectedGroup.id;
    }
    if (this.groupStatusSort) {
      studentDataSearch["groupStatusSort"] =
        this.groupStatusSort != "CLEAR" ? this.groupStatusSort : null;
    }
    if (this.groupStatusFilters) {
      studentDataSearch["groupStatusFilters"] = this.groupStatusFilters;
    }
    studentDataSearch["studentMetrics"] = this.columns;
    return studentDataSearch;
  }

  getStudents() {
    let studentDataSearch = this.getStudentDataSearch();
    this.updateUrlParams(
      studentDataSearch,
      this.selectedView ? this.selectedView.id : null
    );
    // get students and update the student data search object in the store
    this.store.dispatch(new GetStudentDataAction(studentDataSearch));
  }

  setInitialFilters(
    studentDataSearch: studentDataSearch,
    selectedViewId: number
  ) {
    // school filter
    if (studentDataSearch["schoolIds"]) {
      this.initiallySelectedSchoolId = studentDataSearch["schoolIds"][0];
    }
    // teacher filter
    if (studentDataSearch["staffIds"]) {
      this.selectedTeacherId = studentDataSearch["staffIds"][0];
      this.selectedTeacherOrSectionId = studentDataSearch["staffIds"][0];
    }
    // section filter
    if (studentDataSearch["sectionIds"]) {
      this.selectedSectionId = studentDataSearch["sectionIds"][0];
      this.selectedTeacherOrSectionId = studentDataSearch["sectionIds"][0];
    }
    // demographic filters
    if (studentDataSearch["demographicFilters"]) {
      this.selectedDemographicFilters = studentDataSearch["demographicFilters"];
    }
    // metric filters
    if (studentDataSearch["metricFilters"]) {
      this.sortsAndFilters.filterColumns = map(
        studentDataSearch["metricFilters"],
        (column: any) => {
          return {
            student_kpi_id: column.studentKpiId,
            min_value: column.minValue,
            max_value: column.maxValue,
          };
        }
      );
    }
    // metric sorts
    if (studentDataSearch["metricSorts"]) {
      this.sortsAndFilters.sortColumns = map(
        studentDataSearch["metricSorts"],
        (column: any) => {
          return {
            student_kpi_id: column.studentKpiId,
            sort_ascending: column.sortAscending,
          };
        }
      );
    }
    if (studentDataSearch["studentGroupId"]) {
      this.initialSelectedGroupId = studentDataSearch["studentGroupId"];
    }
    studentDataSearch["groupStatusSort"]
      ? (this.groupStatusSort = studentDataSearch["groupStatusSort"])
      : (this.groupStatusSort = "CLEAR");
    studentDataSearch["groupStatusFilters"]
      ? (this.groupStatusFilters = studentDataSearch["groupStatusFilters"])
      : [];

    // we don't store the view in the studentDataSearch object, so need to assign it separately
    this.selectedViewId = selectedViewId;

    // set the pagination
    this.studentCompTable.goToPage(
      studentDataSearch["pageNumber"],
      studentDataSearch["pageSize"]
    );
  }

  updateUrlParams(
    studentDataSearch: studentDataSearch,
    selectedViewId: number
  ) {
    let queryParams = { ...this.activatedRoute.snapshot.queryParams };
    if (studentDataSearch) {
      queryParams = {
        pageNumber: studentDataSearch["pageNumber"],
        pageSize: studentDataSearch["pageSize"],
        schoolId: studentDataSearch["schoolIds"]
          ? studentDataSearch["schoolIds"][0]
          : null,
        staffId: studentDataSearch["staffIds"]
          ? studentDataSearch["staffIds"][0]
          : null,
        sectionId: studentDataSearch["sectionIds"]
          ? studentDataSearch["sectionIds"][0]
          : null,
        metricFilters:
          studentDataSearch["metricFilters"] &&
          studentDataSearch["metricFilters"].length > 0
            ? this.generateMetricString(studentDataSearch["metricFilters"])
            : null,
        metricSorts:
          studentDataSearch["metricSorts"] &&
          studentDataSearch["metricSorts"].length > 0
            ? this.generateMetricString(studentDataSearch["metricSorts"])
            : null,
        studentGroupId: studentDataSearch["studentGroupId"]
          ? studentDataSearch["studentGroupId"]
          : null,
        groupStatusSort: studentDataSearch["groupStatusSort"],
        groupStatusFilters: studentDataSearch["groupStatusFilters"]
          ? studentDataSearch["groupStatusFilters"].join()
          : null,
      };
      if (
        studentDataSearch["demographicFilters"] &&
        studentDataSearch["demographicFilters"].length > 0
      ) {
        studentDataSearch["demographicFilters"].forEach((val, index) => {
          (queryParams[
            "demographicFilterKey" + (index != 0 ? index : "")
          ] = encodeURIComponent(
            studentDataSearch["demographicFilters"][index].key
          )),
            (queryParams[
              "demographicFilterValues" + (index != 0 ? index : "")
            ] =
              studentDataSearch["demographicFilters"][index].values &&
              studentDataSearch["demographicFilters"][index].values.length > 0
                ? this.encodeAndConvertToStringList(
                    studentDataSearch["demographicFilters"][index].values
                  )
                : null);
        });
      }
    }
    queryParams = {
      ...queryParams,
      selectedViewId: selectedViewId,
    };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
    });
  }

  createStudentDataSearchObjFromUrlParams(urlParamMap) {
    let studentDataSearch: studentDataSearch = {};
    let pageNumber = urlParamMap.get("pageNumber");
    let pageSize = urlParamMap.get("pageSize");
    let schoolId = urlParamMap.get("schoolId");
    let staffId = urlParamMap.get("staffId");
    let sectionId = urlParamMap.get("sectionId");
    let demogFilterKeysArray = pickBy(urlParamMap.params, (value, key) => {
      return startsWith(key, "demographicFilterKey");
    });
    let demogFilterValuesArray = pickBy(urlParamMap.params, (value, key) => {
      return startsWith(key, "demographicFilterValues");
    });
    let metricFilters = urlParamMap.get("metricFilters");
    let metricSorts = urlParamMap.get("metricSorts");
    let studentGroupId = urlParamMap.get("studentGroupId");
    let groupStatusSort = urlParamMap.get("groupStatusSort");
    let groupStatusFilters = urlParamMap.get("groupStatusFilters");

    studentDataSearch["pageNumber"] =
      pageNumber != null ? parseInt(pageNumber) : this.currentPageNum;
    studentDataSearch["pageSize"] =
      pageSize != null ? parseInt(pageSize) : this.currentPageSize;
    if (schoolId) {
      studentDataSearch["schoolIds"] = [schoolId];
    }
    if (staffId) {
      studentDataSearch["staffIds"] = [staffId];
    }
    if (sectionId) {
      studentDataSearch["sectionIds"] = [sectionId];
    }
    if (metricFilters) {
      studentDataSearch["metricFilters"] = this.generateMetricArray(
        metricFilters,
        true
      );
    }
    if (metricSorts) {
      studentDataSearch["metricSorts"] = this.generateMetricArray(
        metricSorts,
        false
      );
    }
    if (studentGroupId) {
      studentDataSearch["studentGroupId"] = parseInt(studentGroupId);
    }
    if (groupStatusSort) {
      studentDataSearch["groupStatusSort"] = groupStatusSort;
    }
    if (groupStatusFilters) {
      studentDataSearch["groupStatusFilters"] = groupStatusFilters.split(",");
    }
    // find demographicFilterKey/demographicFilterValue variables
    if (
      demogFilterKeysArray &&
      keys(demogFilterKeysArray).length > 0 &&
      demogFilterValuesArray &&
      keys(demogFilterValuesArray).length > 0
    ) {
      forEach(keys(demogFilterKeysArray), (demogFilterKey) => {
        if (demogFilterKey) {
          let lastChar = parseInt(
            demogFilterKey.slice(
              demogFilterKey.length - 1,
              demogFilterKey.length
            )
          );
          let filterIndex = Number.isInteger(lastChar) ? lastChar : "";
          let filter = {
            key: decodeURIComponent(demogFilterKeysArray[demogFilterKey]),
            values: this.decodeAndConvertToArray(
              demogFilterValuesArray["demographicFilterValues" + filterIndex]
            ),
          };
          if (
            studentDataSearch["demographicFilters"] &&
            studentDataSearch["demographicFilters"].length > 0
          ) {
            studentDataSearch["demographicFilters"].push(filter);
          } else {
            studentDataSearch["demographicFilters"] = [filter];
          }
        }
      });
    }
    return studentDataSearch;
  }

  encodeAndConvertToStringList(arr: Array<string>) {
    return forEach(arr, (val: string) => encodeURIComponent(val)).join();
  }

  decodeAndConvertToArray(str: string) {
    return forEach(str.split(","), (element: string) => {
      decodeURIComponent(element);
    });
  }

  generateMetricString(metricArr: Array<any>) {
    return map(metricArr, (metric) => {
      return values(metric).join();
    }).join("+");
  }

  generateMetricArray(str: string, isFilter: boolean) {
    let decodedString = decodeURIComponent(str);
    let metricArray = [];
    forEach(decodedString.split("+"), (stringPart) => {
      let metricArrayPieces = stringPart.split(",");
      if (isFilter) {
        metricArray.push({
          studentKpiId:
            metricArrayPieces[0] != "" ? parseInt(metricArrayPieces[0]) : null,
          minValue:
            metricArrayPieces[1] != "" ? Number(metricArrayPieces[1]) : null,
          maxValue:
            metricArrayPieces[2] != "" ? Number(metricArrayPieces[2]) : null,
        });
      } else {
        metricArray.push({
          studentKpiId:
            metricArrayPieces[0] != "" ? parseInt(metricArrayPieces[0]) : null,
          sortAscending:
            metricArrayPieces[1] != "" ? metricArrayPieces[1] == "true" : null,
        });
      }
    });
    return metricArray;
  }

  clearAll() {
    this.currentPageNum = 0;
    this.currentPageSize = 10;
    this.initiallySelectedSchoolId = null;
    if (this.schoolsForDropdown && this.schoolsForDropdown.length > 1) {
      // only clear the selected school if we have more than one (otherwise it always displays)
      this.selectedSchool = null;
      this.restoreDistrictOverallHeaderRow();
      this.populateDemographicFilterValues();
    }
    this.selectedTeacherId = null;
    this.selectedSectionId = null;
    this.selectedDemoFilterVals = [];
    this.selectedDemographicFilters = null;
    this.selectedTeacherOrSectionId = null;
    this.selectedTeacherOrSection = null;
    this.sortsAndFilters = { sortColumns: [], filterColumns: [] };
    this.initialSelectedGroupId = null;
    this.groupStatusFilters = null;
    this.groupStatusSort = null;
    this.selectedViewId = null;
    this.selectedView = null;
    this.selectedGroup = null;
    this.selectedListItem = null;
    this.store.dispatch(new UpdateSelectedViewId(null));
    // clear more vars and get students
    this.refreshTable();
  }

  hasTopLevelFilters() {
    return (
      (this.schoolsForDropdown &&
        this.schoolsForDropdown.length > 1 &&
        this.selectedSchool) ||
      this.selectedTeacherId ||
      this.selectedSectionId ||
      (this.selectedDemoFilterVals && this.selectedDemoFilterVals.length > 0)
    );
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  selected(event) {
    //Track school dropdown clicks
    this.kpiService.trackOurStudentsSchoolSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
    if (event.id == "none") {
      this.removeSchool();
      this.populateDemographicFilterValues();
      this.resetToFirstPage();
      this.getStudents();
    } else {
      this.getHeaderRowForSelectedSchool();
      this.getFiltersForSelectedSchool();
    }
  }

  getHeaderRowForSelectedSchool() {
    return this.kpiService
      .getOurStudentsHeaderDataForSchool(this.selectedSchool.id)
      .subscribe(
        (data: SchoolMetadata) => {
          this.schoolOverall = data.school_metrics;
          this.schoolColumns = data.school_columns;
          this.schoolPanels = data.school_panels;
          this.columns = cloneDeep(this.schoolColumns);
          this.panels = cloneDeep(this.schoolPanels);
          this.schoolOverall["name"] = {
            title: "School Overall",
            goalTitle: "School Goal",
          };
          this.school = this.schoolOverall;
          // check for view/list since we've gotten new columns/panels above
          if (this.selectedView) {
            this.updateViewPanel();
          } else if (this.selectedGroup) {
            this.updateGroupPanel();
          }
          this.somethingChanged();
        },
        (error) => {
          this.kpiService.showError(
            error,
            OOPS_MESSAGES.ACCESS_CONTENT,
            OOPS_MESSAGES.RETRIEVE_METRICS_FOR_SCHOOL
          );
        }
      );
  }

  somethingChanged() {
    let vm = this;
    vm.zone.run(function () {
      vm.ducktective.markForCheck();
    });
  }

  values(dict) {
    return Object.keys(dict).map(function (key) {
      return dict[key];
    });
  }

  populateDemographicFilterValues(isFirstTimeInitialization = false) {
    let tmpDistrictDemographics = cloneDeep(this.districtDemographics);
    if (this.selectedSchool && this.selectedUserSchool) {
      tmpDistrictDemographics[
        "Current Grade Level"
      ] = this.selectedUserSchool.demographics["Current Grade Level"];
    }
    // transform demographicsForDropdown into the correct format
    this.demographicsForDropdown = [].concat.apply(
      [],
      map(tmpDistrictDemographics, (vals: Array<string>, key: string) => {
        return map(vals, (val) => {
          return {
            field: key,
            subfield: { name: val, id: val },
          };
        });
      })
    );
    // removing Grade Level At The Time from Our Students demographic dropdown
    this.demographicsForDropdown = filter(
      this.demographicsForDropdown,
      (item) => {
        return item.field != "Grade Level At The Time";
      }
    );
    this.demographicsForDropdown = sortBy(
      this.demographicsForDropdown,
      (item) => {
        return [item.field];
      }
    );
    if (isFirstTimeInitialization && this.selectedDemographicFilters) {
      // we have demographic filters in the url parameters or session that we need to initialize
      if (this.selectedSchool && this.selectedUserSchool) {
        // filter out any selected grade levels in selectedDemographicFilters which don't correspond to this school
        this.selectedDemographicFilters = filter(
          this.selectedDemographicFilters,
          (item) => {
            return (
              item.key != "Current Grade Level" ||
              (item.key == "Current Grade Level" &&
                find(
                  this.selectedUserSchool.demographics["Current Grade Level"],
                  (id) => {
                    return item.values.includes(id);
                  }
                ))
            );
          }
        );
      }
      // set the selectedDemoFilterVals by filtering the demographicsForDropdown by selectedDemographicFilters
      this.selectedDemoFilterVals = filter(
        this.demographicsForDropdown,
        (item) => {
          return this.selectedDemographicFiltersIncludesDropdownValue(item)
            ? item
            : null;
        }
      );
    } else {
      if (this.selectedSchool && this.selectedUserSchool) {
        tmpDistrictDemographics[
          "Current Grade Level"
        ] = this.selectedUserSchool.demographics["Current Grade Level"];
        // filter out any selected grade levels which don't correspond to this school
        this.selectedDemoFilterVals = filter(
          this.selectedDemoFilterVals,
          (item) => {
            return (
              item.field != "Current Grade Level" ||
              (item.field == "Current Grade Level" &&
                find(
                  this.selectedUserSchool.demographics["Current Grade Level"],
                  (id) => {
                    return id == item.subfield.id;
                  }
                ))
            );
          }
        );
        // set the selected demographic filters, which are sent to the realtime students endpoint
        this.selectedDemographicFilters = chain(this.selectedDemoFilterVals)
          .groupBy("field")
          .map((values, key) => {
            return { key: key, values: map(map(values, "subfield"), "id") };
          })
          .filter((obj: any) => {
            return obj.values && obj.values.length > 0;
          })
          .value();
      }
    }
    // update the selected field of demographics for dropdown
    this.demographicsForDropdown = map(
      this.demographicsForDropdown,
      (item: any) => {
        return {
          ...item,
          selected: this.selectedDemographicFiltersIncludesDropdownValue(item),
        };
      }
    );
  }

  selectedDemographicFiltersIncludesDropdownValue(dropdownVal) {
    // check if selectedDemographicFilters (format below)
    /*
      {
        "key": "At Risk Status",
        "values": [
          "Near at Risk"
        ]
      }
     */
    // includes a given value in the demographicsForDropdown format:
    /*
      {
        "field": "At Risk Status",
        "subfield": {
          "name": "Near at Risk",
          "id": "Near at Risk"
        },
        "selected": false
      }
     */
    let d = find(this.selectedDemographicFilters, ["key", dropdownVal.field]);
    return (
      d &&
      dropdownVal &&
      d.values &&
      dropdownVal.subfield &&
      d.values.includes(dropdownVal.subfield.id)
    );
  }

  populateTeachersAndSectionsDropdown() {
    if (this.userInfo.role != "teacher") {
      this.teachersForDropdown = map(
        this.selectedUserSchool.teachers,
        function (teacher: any) {
          return {
            id: teacher["SystemStaffID"],
            text: teacher["teacherName"],
            group: "Teachers",
          };
        }
      );

      this.sectionsForDropdown = map(
        this.selectedUserSchool.sections,
        function (section: any) {
          let teacherNameLabel = section["teacherLastName"];
          if (
            section["teacherFirstName"] &&
            section["teacherFirstName"].length > 0
          ) {
            teacherNameLabel +=
              ", " + section["teacherFirstName"].substring(0, 1) + ".";
          }
          return {
            id: section["sectionID"],
            text:
              section["courseName"] +
              " - " +
              section["classPeriod"] +
              " - " +
              teacherNameLabel,
            systemStaffId: section["systemStaffID"],
            group: "Sections",
          };
        }
      );
    } else {
      this.teachersForDropdown = [];
      this.sectionsForDropdown = map(
        filter(this.selectedUserSchool.sections, (sec) => {
          return sec.teacherEmail == this.userInfo.email;
        }),
        function (section: any) {
          let teacherNameLabel = section["teacherLastName"];
          if (
            section["teacherFirstName"] &&
            section["teacherFirstName"].length > 0
          ) {
            teacherNameLabel +=
              ", " + section["teacherFirstName"].substring(0, 1) + ".";
          }
          return {
            id: section["sectionID"],
            text:
              section["courseName"] +
              " - " +
              section["classPeriod"] +
              " - " +
              teacherNameLabel,
            group: "Sections",
          };
        }
      );
    }
    //Order lists separately by text (so teacher group still appears before section)
    this.teachersForDropdown = orderBy(
      this.teachersForDropdown,
      ["text"],
      ["asc"]
    );
    this.sectionsForDropdown = orderBy(
      this.sectionsForDropdown,
      ["text"],
      ["asc"]
    );
    this.teachersAndSectionsForDropdown = this.teachersForDropdown.concat(
      this.sectionsForDropdown
    );
  }

  filterByTeacherOrSection(event) {
    //Track teacher/section dropdown clicks
    this.kpiService.trackOurStudentsTeacherSectionSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
    this.selectedTeacherOrSection = event;
    this.selectedTeacherId = null;
    this.selectedSectionId = null;
    if (event.group == "Teachers") {
      this.selectedTeacherId = event.id;
      this.filterByTeacher();
    } else {
      this.selectedSectionId = event.id;
      this.selectedTeacherId = event.systemStaffId;
      this.filterBySection();
    }
  }

  filterByTeacher() {
    if (this.selectedTeacherId == "none") {
      this.clearTeacherAndSectionFilter();
    }
    this.resetToFirstPage();
    this.getStudents();
  }

  filterBySection() {
    if (this.selectedSectionId == "none") {
      this.clearTeacherAndSectionFilter();
    }
    this.resetToFirstPage();
    this.getStudents();
  }

  filterByDemographics(filters) {
    if (filters.type == "change") {
      // ng-select is sometimes emitting a second "change" event after the original legitimate event
      return filters.preventDefault();
    }
    //Track demographic multiselect dropdown clicks
    this.kpiService.trackOurStudentsMultiDemographicSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
    this.selectedDemoFilterVals = filters;
    this.selectedDemographicFilters = chain(filters)
      .groupBy("field")
      .map((values, key) => {
        return { key: key, values: map(map(values, "subfield"), "id") };
      })
      .filter((obj: any) => {
        return obj.values && obj.values.length > 0;
      })
      .value();
    this.resetToFirstPage();
    this.getStudents();
  }

  unselectAllDemographicFilters() {
    this.selectedDemoFilterVals = [];
    this.selectedDemographicFilters = [];
    this.resetToFirstPage();
    this.getStudents();
  }

  clearSingleDemographicFilter(f) {
    this.selectedDemoFilterVals = filter(
      this.selectedDemoFilterVals,
      (filterVal) => {
        return !(
          filterVal.field == f.field && filterVal.subfield.id == f.subfield.id
        );
      }
    );
    this.filterByDemographics(this.selectedDemoFilterVals);
  }

  clearTeacherAndSectionFilter() {
    this.selectedTeacherId = null;
    this.selectedSectionId = null;
    this.selectedTeacherOrSection = null;
    this.selectedTeacherOrSectionId = null;
    this.resetToFirstPage();
    this.getStudents();
  }

  removeSchool() {
    this.selectedSchool = null;
    this.restoreDistrictOverallHeaderRow();
  }

  restoreDistrictOverallHeaderRow() {
    this.schoolOverall = this.districtMetrics;
    this.schoolOverall["name"] = {
      title: "District Overall",
      goalTitle: "District Goal",
    };
    this.school = this.schoolOverall;
    this.columns = cloneDeep(this.originalColumns);
    this.panels = cloneDeep(this.originalPanels);
    this.schoolColumns = null;
    this.schoolPanels = null;
    // check for view/list since we've gotten new columns/panels above
    if (this.selectedView) {
      this.updateViewPanel();
    } else if (this.selectedGroup) {
      this.updateGroupPanel();
    }
    this.somethingChanged();
  }

  saveView() {
    let newView: View = {
      id: null,
      name: "",
      description: "",
      sortColumns: this.sortsAndFilters.sortColumns,
      filterColumns: this.sortsAndFilters.filterColumns,
      isSharedWithMe: false,
    };
    this.userViews = [newView, ...this.userViews];
    this.openListSettingsModal("view");
  }

  selectListItemFromDropdown() {
    //Track list dropdown clicks
    this.kpiService.trackOurStudentsListSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
    if (this.selectedListItem.id != -1) {
      if (this.selectedListItem.type == "group") {
        this.selectGroupFromDropdown();
      } else {
        this.selectViewFromDropdown();
      }
    } else {
      this.selectedView = null;
      this.selectedGroup = null;
      this.clearGroupStatusSortsAndFilters();
      this.refreshTable();
    }
    this.store.dispatch(
      new UpdateSelectedViewId(this.selectedView ? this.selectedView.id : null)
    );
  }

  clearGroupStatusSortsAndFilters() {
    this.groupStatusSort = null;
    this.groupStatusFilters = null;
  }

  selectViewFromDropdown() {
    this.selectedView = filter(this.userViews, [
      "id",
      this.selectedListItem.id,
    ])[0];
    this.selectedGroup = null;
    this.clearGroupStatusSortsAndFilters();
    this.sortsAndFilters = cloneDeep(this.selectedView);
    this.updateViewPanel();
    this.resetToFirstPage();
    this.getStudents();
  }

  selectGroupFromDropdown() {
    this.selectedGroup = filter(this.groups, [
      "id",
      this.selectedListItem.id,
    ])[0];
    this.selectedView = null;
    // clear the sorts and filters in case our last selected item was a view
    this.sortsAndFilters = { sortColumns: [], filterColumns: [] };
    this.kpiService.trackStudentGroupSelect(this.selectedGroup.id).subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
    this.updateGroupPanel();
    this.resetToFirstPage();
    this.getStudents();
  }

  updateViewPanel() {
    this.clearExistingCustomPanels();
    // We've selected a new view. Update the title, and the studentKpiIds array based on the sort/filter columns
    let newViewPanelKpiIds = this.getStudentKpiIdArray(
      this.selectedView.sortColumns,
      this.selectedView.filterColumns
    );
    // account for hidden metrics
    newViewPanelKpiIds = this.removeHiddenKpiIds(newViewPanelKpiIds);
    if (newViewPanelKpiIds && newViewPanelKpiIds.length > 0) {
      // remove the studentKpis in the panels where the kpis were taken out of
      this.removeStudentKpiIdsFromCurrentPanels(newViewPanelKpiIds);
    }
    let newViewPanel = {
      studentKpiIds: newViewPanelKpiIds,
      title: "View: " + this.selectedView.name,
      sortOrder: 0,
      isViewPanel: true,
    };
    // add the new view panel
    this.panels.unshift(newViewPanel);
    // order columns to match panel order
    this.orderColumnsByPanelOrder("view");
  }

  updateGroupPanel(isPopulatingFromStore: boolean = false) {
    this.clearExistingCustomPanels();
    // get an array of efficacy criteria student kpi ids
    let efficacyCriteriaStudentKpiIds: Array<number> = map(
      this.selectedGroup.efficacyCriteria,
      "student_kpi_id"
    );
    // account for hidden metrics
    efficacyCriteriaStudentKpiIds = this.removeHiddenKpiIds(
      efficacyCriteriaStudentKpiIds
    );
    // remove the student kpi ids from their current panels (if there are efficacy criteria student kpi ids)
    if (
      efficacyCriteriaStudentKpiIds &&
      efficacyCriteriaStudentKpiIds.length > 0
    )
      this.removeStudentKpiIdsFromCurrentPanels(efficacyCriteriaStudentKpiIds);
    // create the new group panel, including the group status column
    let newGroupPanel = {
      studentKpiIds: [-1, ...efficacyCriteriaStudentKpiIds],
      title: "Group: " + this.selectedGroup.name,
      sortOrder: 0,
      isGroupPanel: true,
    };
    // add the new group panel
    this.panels.unshift(newGroupPanel);
    // order columns to match panel order
    this.orderColumnsByPanelOrder("group");
    if (!isPopulatingFromStore) {
      // set the default sort
      this.groupStatusSort = "DESC";
      // set the default filter (no filter)
      this.groupStatusFilters = [
        "in_group_but_does_not_meet_criteria",
        "in_group_and_meets_criteria",
        "out_of_group_but_meets_criteria",
      ];
    }
  }

  removeHiddenKpiIds(kpiIds) {
    // get visible kpi ids
    let visibleKpiIds: Array<number> = map(this.columns, "id");
    // filter out any which are not visible
    return filter(kpiIds, (id) => {
      return visibleKpiIds.indexOf(id) > -1;
    });
  }

  removeStudentKpiIdsFromCurrentPanels(kpiIdArray) {
    this.panels = map(this.panels, (panel: any) => {
      let panelNewKpiIds = filter(
        panel.studentKpiIds,
        (studentKpiId: number) => {
          return kpiIdArray.indexOf(studentKpiId) == -1;
        }
      );
      return { ...panel, studentKpiIds: panelNewKpiIds };
    });
  }

  orderColumnsByPanelOrder(type: string) {
    // create an array of the column ids of the panels, to use for sorting
    let panelsColumnIdArray = flatten(
      map(this.panels, (obj: any) => {
        return obj.studentKpiIds;
      })
    );
    // sort the columns by the above array
    this.columns = sortBy(this.columns, (item) => {
      return panelsColumnIdArray.indexOf(item.id);
    });
    if (type == "group") {
      // add the Group Status column
      this.columns = [
        { title: "Group Status", id: -1, roundTo: null },
        ...this.columns,
      ];
    }
  }

  clearExistingCustomPanels() {
    if (
      find(this.panels, ["isViewPanel", true]) ||
      find(this.panels, ["isGroupPanel", true])
    ) {
      // We already have a view or group panel, clear it first
      if (this.selectedSchool) {
        this.panels = cloneDeep(this.schoolPanels);
        this.columns = cloneDeep(this.schoolColumns);
      } else {
        this.panels = cloneDeep(this.originalPanels);
        this.columns = cloneDeep(this.originalColumns);
      }
    }
  }

  getStudentKpiIdArray(sortCols, filterCols) {
    // we want a unique list of the student_kpi_ids that are sorted and/or filtered, ordered alphabetically
    // we also filter the ids to make sure they're all in the list of columns, to avoid "metric no longer in dashboard" mismatch
    return chain(
      union(map(sortCols, "student_kpi_id"), map(filterCols, "student_kpi_id"))
    )
      .filter((studentKpiId) => {
        return find(this.columns, ["id", studentKpiId]);
      })
      .sortBy((studentKpiId) => {
        let column = find(this.columns, ["id", studentKpiId]);
        return column ? column.title : null;
      })
      .value();
  }

  hasFilteredOrSorted() {
    return (
      this.sortsAndFilters &&
      ((this.sortsAndFilters.sortColumns &&
        this.sortsAndFilters.sortColumns.length > 0) ||
        (this.sortsAndFilters.filterColumns &&
          this.sortsAndFilters.filterColumns.length > 0))
    );
  }

  differentFromSavedView() {
    if (this.selectedView) {
      return (
        !isEqual(
          this.selectedView.sortColumns,
          this.sortsAndFilters.sortColumns
        ) ||
        !isEqual(
          this.selectedView.filterColumns,
          this.sortsAndFilters.filterColumns
        )
      );
    } else {
      return true;
    }
  }

  openListSettingsModal(type?, item?) {
    let dialogRef = this.dialog.open(ListSettingsModalComponent, {
      width: "80%",
      height: "90%",
      data: {
        columns: this.columns,
        schools: this.schools,
        userViews: this.userViews,
        groups: this.groups,
        isAdminUser: this.userInfo && this.userInfo.role == "admin",
        isSLUser: this.userInfo && this.userInfo.role == "school_leader",
        isStarterUser:
          this.userInfo && this.userInfo.sz_tier == TIERS.STARTER.key,
        type,
        initiallySelectedItem: item,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (
          find(this.userViews, ["id", null]) &&
          !find(result.views, ["id", null])
        ) {
          // "save new view" path
          this.handleAddingNewViewResult(result.views);
        } else if (
          find(this.groups, ["id", null]) &&
          !find(result.groups, ["id", null])
        ) {
          // "save new group" path
          this.handleAddingNewGroup(result.groups);
        } else {
          // "edit existing" path
          this.handleEditExistingViewResult(result.views);
          this.handleEditExistingGroupResult(result.groups);
        }
        //Trigger change detection in the view
        this.somethingChanged();
      }
    });
    if (type == "group") {
      this.kpiService
        .trackModalOpened(
          "create new student group",
          this.selectedGroup != null
        )
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    } else if (type == "view") {
      this.kpiService
        .trackModalOpened("create new view", this.selectedGroup != null)
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    } else {
      this.kpiService
        .trackModalOpened("edit list settings", this.selectedGroup != null)
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    }
  }

  handleAddingNewViewResult(result) {
    // remove the null "new view" placeholder
    this.userViews = filter(this.userViews, (view) => {
      return view.id != null;
    });
    // the newly added view is the item that's different between the views we had before and the views we have now
    let newView = differenceWith(result, this.userViews, isEqual)[0];
    this.userViews = result;
    // add the user view for dropdown
    let newListItem = {
      id: newView["id"],
      text: newView["name"],
      type: "view",
      list: newView["isSharedWithMe"] ? "Views Shared with Me" : "My Views",
    };
    this.userViewsForDropdown.push(newListItem);
    this.userViewsForDropdown = orderBy(
      this.userViewsForDropdown,
      [(view) => view["list"], (view) => view["text"].toLowerCase()],
      ["asc", "asc"]
    );
    // regenerate the lists dropdown
    this.generateListsDropdown();
    // select this view in the dropdown
    this.selectedView = newView;
    this.store.dispatch(
      new UpdateSelectedViewId(this.selectedView ? this.selectedView.id : null)
    );
    this.updateUrlParams(null, this.selectedView ? this.selectedView.id : null);
    this.selectedListItem = newListItem;
    // clear any previous group
    this.selectedGroup = null;
    this.clearGroupStatusSortsAndFilters();
    this.updateViewPanel();
  }

  handleAddingNewGroup(result) {
    // remove the null "new group" placeholder
    this.groups = filter(this.groups, (group) => {
      return group.id != null;
    });
    // the newly added group is the item that's different between the groups we had before and the groups we have now
    let newGroup = differenceWith(result, this.groups, isEqual)[0];
    this.groups = result;
    // add group for dropdown
    let newListItem = {
      id: newGroup["id"],
      text: newGroup["name"],
      type: "group",
      list: newGroup["isSharedWithMe"] ? "Groups Shared with Me" : "My Groups",
    };
    this.groupsForDropdown.push(newListItem);
    this.groupsForDropdown = orderBy(
      this.groupsForDropdown,
      [(group) => group["list"], (group) => group["text"].toLowerCase()],
      ["desc", "asc"]
    );
    this.generateListsDropdown();
    // select new group in the dropdown
    this.selectedGroup = newGroup;
    this.selectedListItem = newListItem;
    // clear any selected view
    this.selectedView = null;
    this.store.dispatch(new UpdateSelectedViewId(null));
    // clear the sorts and filters in case our last selected item was a view
    this.sortsAndFilters = { sortColumns: [], filterColumns: [] };
    // move group criteria kpis to their own group panel
    this.updateGroupPanel();
    // get new list of students for group
    this.resetToFirstPage();
    this.getStudents();
  }

  handleEditExistingViewResult(result) {
    // here we get back the new list of views (can be the same as the old list if the user hasn't deleted anything)
    // we remove the unsaved "create new view" object if there is one
    // we generate a new list of userViewsForDropdown
    // we update the userViewsForDropdown
    // we see if the currently selected view is in the list of views still, otherwise we go back to "No view"
    result = filter(result, (view) => {
      return view.id != null;
    });
    this.userViews = result;
    // generate this.userViewsForDropdown
    this.userViewsForDropdown = this.generateListItemsForDropdown(
      this.userViews,
      "view"
    );
    this.generateListsDropdown();
    if (this.selectedView && this.selectedView.id) {
      let selectedViewFromResults: View = find(this.userViews, [
        "id",
        this.selectedView.id,
      ]);
      if (!selectedViewFromResults) {
        // if the selected view has been deleted, clear the view
        this.selectedView = null;
        this.selectedListItem = null;
        this.store.dispatch(new UpdateSelectedViewId(null));
        this.refreshTable();
      } else if (
        selectedViewFromResults &&
        selectedViewFromResults.name != this.selectedView.name
      ) {
        // the currently selected view's name has been updated in the results, so update the dropdown
        this.selectedListItem = find(this.userViewsForDropdown, [
          "id",
          selectedViewFromResults.id,
        ]);
        this.selectedView = selectedViewFromResults;
      }
    }
  }

  handleEditExistingGroupResult(result) {
    // here we get back the new list of groups (can be the same as the old list if the user hasn't deleted anything)
    // we remove the unsaved "create new group" object if there is one
    // we generate a new list of groupsForDropdown
    // we see if the currently selected group is in the list of groups still, otherwise we go back to "No group"
    result = filter(result, (group) => {
      return group.id != null;
    });
    this.groups = result;
    // generate this.groupsForDropdown
    this.groupsForDropdown = this.generateListItemsForDropdown(
      this.groups,
      "group"
    );
    this.generateListsDropdown();
    if (this.selectedGroup && this.selectedGroup.id) {
      let selectedGroupFromResults: Group = find(this.groups, [
        "id",
        this.selectedGroup.id,
      ]);
      if (!selectedGroupFromResults) {
        // if the selected group has been deleted, clear the group
        this.selectedGroup = null;
        this.selectedListItem = null;
        this.clearGroupStatusSortsAndFilters();
        this.refreshTable();
      } else if (!isEqual(selectedGroupFromResults, this.selectedGroup)) {
        // the selected group has been updated in the modal
        let hasUpdatedCriteria: boolean = !isEqual(
          selectedGroupFromResults.efficacyCriteria,
          this.selectedGroup.efficacyCriteria
        );
        let hasUpdatedName: boolean =
          selectedGroupFromResults.name != this.selectedGroup.name;
        // update the selected group with the new results (needs to happen before updating the group panel)
        this.selectedGroup = selectedGroupFromResults;
        if (hasUpdatedName || hasUpdatedCriteria) {
          // the currently selected group's name or criteria has changed: update the group panel
          this.updateGroupPanel();

          if (hasUpdatedName) {
            // the currently selected group's name has changed: update the dropdown
            this.selectedListItem = find(this.groupsForDropdown, [
              "id",
              this.selectedGroup.id,
            ]);
          }
          if (hasUpdatedCriteria) {
            // get the new list of students (since the criteria changed)
            this.resetToFirstPage();
            this.getStudents();
          }
        }
      }
    }
  }

  changePage(event: PageEvent) {
    if (this.currentPageSize != event.pageSize) {
      this.kpiService.trackPageSizeSelect(event.pageSize).subscribe(
        (data) => {},
        (error) => {
          console.error(error);
        }
      );
    }
    this.currentPageNum = event.pageIndex;
    this.currentPageSize = event.pageSize;
    this.getStudents();
  }

  getFileName() {
    let fileName = "OurStudents";
    let currentDate = formatDate(new Date(), "yyyy-MM-dd", "en");
    let schoolName = this.selectedSchool
      ? this.selectedSchool.text.replace(/\s/g, "")
      : "AllSchools";
    let filterName = "";
    if (this.selectedDemoFilterVals) {
      if (this.selectedDemoFilterVals.length == 1) {
        filterName = (
          "_" +
          this.selectedDemoFilterVals[0].field +
          "_" +
          this.selectedDemoFilterVals[0].subfield.id
        ).replace(/\s/g, "");
      } else if (this.selectedDemoFilterVals.length > 1) {
        filterName = "_Multiple";
      }
    }
    let teacherOrSectionName = "";
    if (this.selectedTeacherOrSection) {
      teacherOrSectionName =
        "_" +
        this.selectedTeacherOrSection.group +
        "_" +
        this.selectedTeacherOrSection.text.replace(/\s/g, "").replace(",", "_");
    }
    let listItem = this.selectedListItem
      ? "_" + this.selectedListItem.text.replace(/\s/g, "")
      : "";
    fileName = encodeURIComponent(
      currentDate +
        "_" +
        fileName +
        "_" +
        schoolName +
        filterName +
        teacherOrSectionName +
        listItem
    ).substring(0, 250);
    return fileName + ".csv";
  }

  exportToCSV() {
    this.exportingStudentData = true;
    //Trigger change detection in the view
    this.somethingChanged();
    let studentDataSearch = this.getStudentDataSearch();
    let fileName = this.getFileName();
    this.kpiService.getCSV(studentDataSearch, this.totalCount).subscribe(
      (data) => {
        let binaryData = [];
        binaryData.push(data);
        let url = window.URL.createObjectURL(
          new Blob(binaryData, { type: "text/csv" })
        );
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName; // gives it a name via an a tag
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.exportingStudentData = false;
        this.showExportCompletedMessage();
        this.kpiService.trackOurStudentExportToCSVSuccess().subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
      },
      (error) => {
        console.error(error);
        this.exportingStudentData = false;
        this.showExportFailedMessage();
      }
    );
  }

  refreshTable() {
    if (this.selectedSchool) {
      // get school panels/columns
      this.panels = cloneDeep(this.schoolPanels);
      this.columns = cloneDeep(this.schoolColumns);
    } else {
      this.panels = cloneDeep(this.originalPanels);
      this.columns = cloneDeep(this.originalColumns);
    }
    // we want to clear the student sort filters obj
    this.sortsAndFilters = { sortColumns: [], filterColumns: [] };
    this.resetToFirstPage();
    this.getStudents();
  }

  resetToFirstPage() {
    this.currentPageNum = 0;
    this.studentCompTable.goToFirstPage();
    this.setPagination();
  }

  setPagination() {
    // set the pagination
    this.studentCompTable.goToPage(this.currentPageNum, this.currentPageSize);
  }

  sortsFiltersSelected(event) {
    this.resetToFirstPage();

    if (event.kpi.id == -1) {
      if (event.sort) {
        this.groupStatusSort = event.sort;
        // clear any metric sorts
        this.sortsAndFilters = { ...this.sortsAndFilters, sortColumns: [] };
      }
      if (event.groupStatusFilters) {
        this.groupStatusFilters = event.groupStatusFilters;
      }
      this.getStudents();
      return;
    }
    if (event.sort && event.sort != "CLEAR") {
      // remove the group status sort if there
      this.groupStatusSort = "CLEAR";
      // we're sorting ASC/DESC by this new column now
      this.sortsAndFilters.sortColumns = [
        {
          student_kpi_id: event.kpi.id,
          sort_ascending: this.getSortBool(event.sort),
        },
      ];
    } else if (event.sort && event.sort == "CLEAR") {
      // we want to remove this sort column (if it's there)
      this.sortsAndFilters.sortColumns = filter(
        this.sortsAndFilters.sortColumns,
        (sortCol) => {
          return sortCol.student_kpi_id != event.kpi.id;
        }
      );
    }
    if (event.filter != null) {
      // remove current kpi filter if there
      this.sortsAndFilters.filterColumns = filter(
        this.sortsAndFilters.filterColumns,
        (filterCol) => {
          return filterCol.student_kpi_id != event.kpi.id;
        }
      );
      switch (event.filter.id) {
        case 2:
          // between case
          this.sortsAndFilters.filterColumns.push({
            student_kpi_id: event.kpi.id,
            min_value: event.min,
            max_value: event.max,
          });
          break;
        case 3:
          // greater than case
          this.sortsAndFilters.filterColumns.push({
            student_kpi_id: event.kpi.id,
            min_value: event.singleVal,
            max_value: null,
          });
          break;
        case 4:
          // less than case
          this.sortsAndFilters.filterColumns.push({
            student_kpi_id: event.kpi.id,
            min_value: null,
            max_value: event.singleVal,
          });
          break;
        case 5:
          // equal to case
          this.sortsAndFilters.filterColumns.push({
            student_kpi_id: event.kpi.id,
            min_value: event.singleVal,
            max_value: event.singleVal,
          });
          break;
      }
    }
    this.getStudents();
  }

  studentSelected(selectedStudentKEY) {
    this.store.dispatch(new SelectStudentAction(selectedStudentKEY));
    this.kpiService.trackStudentSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
  }

  selectAllChange(change) {
    this.store.dispatch(new SelectAllStudentsAction(change.checked));
    this.kpiService.trackAllStudentsSelect().subscribe(
      (data) => {},
      (error) => {
        console.error(error);
      }
    );
  }

  addGroup() {
    let studentsToAdd: Array<student> = filter(this.students, [
      "selected",
      true,
    ]);
    let newGroup: Group = {
      id: null,
      name: "",
      description: "",
      efficacyCriteria: [],
      isSharedWithMe: false,
      studentsInGroup: map(studentsToAdd, (student: student) => {
        return student.studentKEY;
      }),
    };
    this.groups = [newGroup, ...this.groups];
    this.openListSettingsModal("group");
  }

  addStudentsToGroup() {
    let studentsToAdd: Array<student> = filter(this.students, [
      "selected",
      true,
    ]);
    let studentsInGroup: Array<number> = map(
      studentsToAdd,
      (student: student) => {
        return student.studentKEY;
      }
    );
    this.openUpdateStudentsInGroupModal(studentsInGroup, "ADD STUDENTS");
  }

  removeStudentsFromGroup() {
    let studentsToAdd: Array<student> = filter(this.students, [
      "selected",
      true,
    ]);
    let studentsInGroup: Array<number> = map(
      studentsToAdd,
      (student: student) => {
        return student.studentKEY;
      }
    );
    this.openUpdateStudentsInGroupModal(studentsInGroup, "REMOVE STUDENTS");
  }

  showStudentsAddedMessage(numberOfStudentsAdded, alreadyAdded, groupName) {
    let successMessage = "";
    let alreadyAddedMessage =
      alreadyAdded == 1
        ? alreadyAdded + " student was already a member of the group."
        : alreadyAdded + " students were already members of the group.";
    if (numberOfStudentsAdded == 1) {
      successMessage =
        numberOfStudentsAdded +
        " student was added to the " +
        groupName +
        " group. " +
        alreadyAddedMessage;
    } else {
      successMessage =
        numberOfStudentsAdded +
        " students were added to the " +
        groupName +
        " group. " +
        alreadyAddedMessage;
    }
    this.snackBar.open(successMessage, "DISMISS", {
      duration: 3000,
    });
  }

  showStudentsRemovedMessage(numberOfStudentsRemoved, groupName) {
    let successMessage = "";
    if (numberOfStudentsRemoved == 1) {
      successMessage =
        numberOfStudentsRemoved +
        " student was removed from the " +
        groupName +
        " group.";
    } else {
      successMessage =
        numberOfStudentsRemoved +
        " students were removed from the " +
        groupName +
        " group.";
    }
    this.snackBar.open(successMessage, "DISMISS", {
      duration: 3000,
    });
  }

  showExportCompletedMessage() {
    let successMessage = "Your CSV export is downloaded and ready for viewing!";
    this.snackBar.open(successMessage, "DISMISS", {
      duration: 3000,
    });
  }

  showExportFailedMessage() {
    let successMessage =
      "We're sorry.  An error occurred during your CSV export.";
    this.snackBar.open(successMessage, "DISMISS", {
      duration: 3000,
    });
  }

  openUpdateStudentsInGroupModal(studentsInGroup, action = "ADD STUDENTS") {
    let dialogRef = this.dialog.open(AddStudentsToGroupModalComponent, {
      width: "30%",
      height: "70%",
      data: {
        columns: this.columns,
        groups: filter(this.groups, ["isSharedWithMe", false]),
        students: studentsInGroup,
        selectedGroup: this.selectedGroup,
        action: action,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //De-select all students
        this.selectAllChange(false);

        //Show success message
        if (result.action == "ADD STUDENTS") {
          this.showStudentsAddedMessage(
            result.numberOfStudentsAdded,
            result.alreadyAdded,
            result.groupName
          );
        } else {
          this.showStudentsRemovedMessage(
            result.numberOfStudentsRemoved,
            result.groupName
          );
        }

        //Update the number of students in the group, for display in the "Edit List" modal
        let groupToUpdate: Group = find(this.groups, ["id", result.groupId]);
        if (groupToUpdate) {
          groupToUpdate.studentsInGroup = result.studentsInGroup;
        }

        //If a student group is selected, refresh the students table with new status icons
        if (this.selectedGroup) {
          this.getStudents();
        } else {
          //Trigger change detection in the view
          this.somethingChanged();
        }
      }
    });
    if (action == "ADD STUDENTS") {
      this.kpiService
        .trackModalOpened("add students to group", this.selectedGroup != null)
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    } else {
      this.kpiService
        .trackModalOpened(
          "remove students from group",
          this.selectedGroup != null
        )
        .subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
    }
  }

  openExportToCSVModal() {
    let dialogRef = this.dialog.open(ExportStudentsToCsvModalComponent, {
      data: {
        studentCount: this.totalCount,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.kpiService.trackOurStudentExportToCSVInitiated().subscribe(
          (data) => {},
          (error) => {
            console.error(error);
          }
        );
        this.exportToCSV();
      }
    });
    this.kpiService
      .trackModalOpened("export students to csv", this.selectedGroup != null)
      .subscribe(
        (data) => {},
        (error) => {
          console.error(error);
        }
      );
  }

  getSortBool(sort) {
    if (sort == "ASC") {
      return true;
    } else if (sort == "DESC") {
      return false;
    } else {
      return null;
    }
  }
}
